import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid, Type } from '../../../app/StyleGuide';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 700px;
  margin: 0 auto;
  padding: ${Grid._6} ${Grid._4};
  text-align: center;
`;

export const TrainingPosterContainer = styled.div`
  max-width: 300px;
  width: 100%;
  margin-bottom: ${Grid._5};

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    max-width: 400px;
  }
`;

export const Subtitle = styled.span`
  font-size: 20px;
  margin: 0 0 -12px 0;
`;

export const TrainingName = styled.h1`
  font-size: ${Type.Scale._7};
  font-weight: ${Type.Weight.bold};
  color: ${Type.Color.dark};
  margin: 0 0 ${Grid._4} 0;
`;

export const TitleContainer = styled.div`
  margin-top: ${Grid._10};
`;

export const Description = styled.p`
  font-size: ${Type.Scale._3};
  color: ${Type.Color.medium};
  line-height: 1.6;
  margin: 0 0 ${Grid._10} 0;
`;
